import SmallArrow from 'components/icons/SmallArrow'
import css from './styles.module.scss'
import classnames from 'classnames/bind'

const cx = classnames.bind(css)

const DropdownButton = ({ isOpen, label, onClick }) => {
  return (
    <button className={cx(css.Button)} onClick={onClick}>
      {label}
      <SmallArrow
        theme="current-color"
        className={cx(css.smallArrow, isOpen ? css.arrowUp : css.arrowDown)}
      />
    </button>
  )
}

export default DropdownButton
